import { render, staticRenderFns } from "./Cookies.vue?vue&type=template&id=59d39f0b&scoped=true&"
import script from "./Cookies.vue?vue&type=script&lang=js&"
export * from "./Cookies.vue?vue&type=script&lang=js&"
import style0 from "../assets/styles/gdpr.css?vue&type=style&index=0&id=59d39f0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d39f0b",
  null
  
)

export default component.exports